import { Thumbnail } from '../../../Thumbnail/Thumbnail';

import type { FC } from 'react';

import styles from './Story.module.scss';

type Props = {
  asset: {
    images?: { main?: string | null };
    title?: string;
  };
  className?: string;
};

const Story: FC<Props> = ({ asset, className }) => {
  return (
    <div className={className}>
      <Thumbnail
        url={`${asset.images?.main}?t[]=180q80`}
        alt={asset.title}
        aspectRatio="9/16"
      />
      <div className={styles.title}>{asset.title}</div>
    </div>
  );
};

export { Story };
